import "leaflet/dist/leaflet.css";

import L from "leaflet";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { CircleMarker, MapContainer, Popup, TileLayer } from "react-leaflet";
import { Link } from "react-router-dom";

// Fix for default marker icons in Leaflet with React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Delivery locations with coordinates
const deliveryLocations = [
  // Indiana (home base and suburbs)
  {
    city: "Indianapolis",
    state: "IN",
    lat: 39.7684,
    lng: -86.1581,
    type: "home",
    sold: true,
  },
  {
    city: "Carmel",
    state: "IN",
    lat: 39.9784,
    lng: -86.118,
    type: "suburb",
    sold: true,
  },
  {
    city: "Fishers",
    state: "IN",
    lat: 39.9568,
    lng: -86.0139,
    type: "suburb",
    sold: true,
  },
  {
    city: "Westfield",
    state: "IN",
    lat: 40.0428,
    lng: -86.1276,
    type: "suburb",
    sold: true,
  },
  {
    city: "Noblesville",
    state: "IN",
    lat: 40.0456,
    lng: -86.0086,
    type: "suburb",
    sold: true,
  },
  {
    city: "Zionsville",
    state: "IN",
    lat: 39.9509,
    lng: -86.2619,
    type: "suburb",
    sold: true,
  },
  {
    city: "Avon",
    state: "IN",
    lat: 39.7628,
    lng: -86.3997,
    type: "suburb",
    sold: true,
  },
  {
    city: "Plainfield",
    state: "IN",
    lat: 39.7042,
    lng: -86.3994,
    type: "suburb",
    sold: true,
  },
  {
    city: "Greenwood",
    state: "IN",
    lat: 39.6137,
    lng: -86.1067,
    type: "suburb",
    sold: true,
  },
  {
    city: "Brownsburg",
    state: "IN",
    lat: 39.8434,
    lng: -86.3956,
    type: "suburb",
    sold: true,
  },

  // Cities where puppies have been sold
  {
    city: "Greenville",
    state: "SC",
    lat: 34.8526,
    lng: -82.394,
    type: "sold",
    sold: true,
    url: "/greenville",
  },
  {
    city: "Columbia",
    state: "SC",
    lat: 34.0007,
    lng: -81.0348,
    type: "sold",
    sold: true,
    url: "/columbia",
  },
  {
    city: "Champaign-Urbana",
    state: "IL",
    lat: 40.1164,
    lng: -88.2434,
    type: "sold",
    sold: true,
    url: "/champaign-urbana",
  },
  {
    city: "Chicago",
    state: "IL",
    lat: 41.8781,
    lng: -87.6298,
    type: "sold",
    sold: true,
    url: "/chicago",
  },
  {
    city: "Minneapolis",
    state: "MN",
    lat: 44.9778,
    lng: -93.265,
    type: "sold",
    sold: true,
    url: "/minneapolis",
  },
  {
    city: "New York",
    state: "NY",
    lat: 40.7128,
    lng: -74.006,
    type: "sold",
    sold: true,
    url: "/new-york",
  },
  {
    city: "Boston",
    state: "MA",
    lat: 42.3601,
    lng: -71.0589,
    type: "sold",
    sold: true,
    url: "/boston",
  },
];

export const DeliveryMap = () => {
  const soldCities = deliveryLocations.filter(
    (loc) => loc.sold && loc.type !== "home" && loc.type !== "suburb",
  );

  return (
    <div
      style={{
        backgroundColor: "var(--almond-light)",
        padding: "60px 0",
        marginTop: "40px",
      }}
    >
      <Container>
        <Row className="mb-5">
          <Col>
            <h2
              style={{
                textAlign: "center",
                fontSize: "2.5rem",
                fontWeight: "bold",
                color: "var(--sea-green-dark)",
                marginBottom: "1rem",
              }}
            >
              Nationwide Puppy Delivery
            </h2>
            <p
              style={{
                textAlign: "center",
                fontSize: "1.2rem",
                color: "var(--text-color-light)",
                maxWidth: "800px",
                margin: "0 auto",
              }}
            >
              {
                "We've successfully delivered trained puppies across the United States. See where our puppies have found their forever homes!"
              }
            </p>
          </Col>
        </Row>

        {/* Interactive Leaflet Map */}
        <Row className="mb-5">
          <Col>
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                padding: "20px",
                boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
              }}
            >
              <MapContainer
                center={[39.8283, -98.5795]}
                zoom={4}
                style={{
                  height: "500px",
                  width: "100%",
                  borderRadius: "8px",
                }}
                scrollWheelZoom={false}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {deliveryLocations.map((location, index) => {
                  return (
                    <CircleMarker
                      key={index}
                      center={[location.lat, location.lng]}
                      radius={8}
                      fillColor="#2ca49c"
                      color="#fff"
                      weight={2}
                      opacity={1}
                      fillOpacity={0.8}
                    >
                      <Popup>
                        <div style={{ textAlign: "center" }}>
                          <strong
                            style={{ color: "#00756e", fontSize: "1.1rem" }}
                          >
                            {location.city}, {location.state}
                          </strong>
                          <br />
                          {location.url && (
                            <Link
                              to={location.url}
                              style={{
                                color: "#c16552",
                                textDecoration: "none",
                                fontWeight: "500",
                                marginTop: "5px",
                                display: "inline-block",
                              }}
                            >
                              Learn More →
                            </Link>
                          )}
                        </div>
                      </Popup>
                    </CircleMarker>
                  );
                })}
              </MapContainer>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "30px",
                  marginTop: "20px",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      borderRadius: "50%",
                      backgroundColor: "#2ca49c",
                      border: "2px solid #fff",
                    }}
                  />
                  <span
                    style={{
                      fontSize: "0.9rem",
                      color: "var(--text-color-light)",
                    }}
                  >
                    Puppy Delivered Here
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mb-5 text-center">
          <Col md={6}>
            <div style={{ padding: "20px" }}>
              <h3
                style={{
                  fontSize: "3rem",
                  fontWeight: "bold",
                  color: "#2ca49c",
                }}
              >
                {soldCities.length}
              </h3>
              <p
                style={{ fontSize: "1.1rem", color: "var(--text-color-light)" }}
              >
                Cities Delivered To
              </p>
            </div>
          </Col>
          <Col md={6}>
            <div style={{ padding: "20px" }}>
              <h3
                style={{
                  fontSize: "3rem",
                  fontWeight: "bold",
                  color: "#b3a390",
                }}
              >
                50+
              </h3>
              <p
                style={{ fontSize: "1.1rem", color: "var(--text-color-light)" }}
              >
                States Available
              </p>
            </div>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <h3
              style={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                color: "#00756e",
                marginBottom: "1.5rem",
                textAlign: "center",
              }}
            >
              {"Cities We've Delivered To"}
            </h3>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                justifyContent: "center",
                fontSize: "1.1rem",
                color: "var(--text-color-light)",
              }}
            >
              {/* Indianapolis Metro Area */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#c16552",
                    display: "inline-block",
                  }}
                />
                Indianapolis Metro Area, IN
              </div>

              {/* Other cities */}
              {soldCities.map((location, index) =>
                location.url ? (
                  <Link
                    key={index}
                    to={location.url}
                    style={{
                      textDecoration: "none",
                      color: "var(--text-color-light)",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.3s ease",
                    }}
                    className="city-link"
                  >
                    <span
                      style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: "#c16552",
                        display: "inline-block",
                      }}
                    />
                    {location.city}, {location.state}
                  </Link>
                ) : (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span
                      style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: "#c16552",
                        display: "inline-block",
                      }}
                    />
                    {location.city}, {location.state}
                  </div>
                ),
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .city-link:hover {
          color: #c16552 !important;
          transform: translateX(5px);
        }
      `}</style>
    </div>
  );
};
